import { FC } from "react";
import { withProcedureWraper } from "../../../..";
import { Icon } from "../../../../../../components";
import { useHistory } from "react-router-dom";
import {
  ExportProgress,
  ExportInformation,
  ExportHistory,
  ExportList,
} from "../../components";
import { CreateNotification } from "../../../../../../components/notifier";
import { requestStatus } from "../../../../../../constants";
import { useSelector } from "../../../../../../store/store";
import { Skeleton, Form, Modal, Input } from "antd";
import { useRouteMatch } from "react-router-dom";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getEnv } from "../../../../../../AppConfigs";
import { MailService } from "../../../../../../services/mail/mail.service";
import { mailRegexs } from "../../../../../../constants/mailTemplateConstants";
import { getDDMMYYYFormat } from "../../../../../../helper/dateTimeHelper";
import { getHHmmFormat } from "../../../../../../helper/dateTimeHelper";
import { useEmployee } from "../../../../../../hook";
import {
  StyledButton,
  StyledTitle,
} from "../../../../../../components/styled-antd";
import { MAIL_TEMPLATE, PATH } from "../../constant";
import { isEnableEdit } from "../../utils";
import { getEmployeeDetail } from "../../utils/get-employee-detail";
import { HOSummaryEmployeeRequestService } from "../../../../../../services/human-organization/summary-register-request.service";

export const Detail: FC = withProcedureWraper(() => {
  const [form] = Form.useForm();

  const history = useHistory();
  const { id } = useRouteMatch().params as any;
  const [eRequests, setERequests] = useState<any[]>([]);
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username?.toString().toLowerCase();
  const mailtemplates = useSelector(
    (state: any) => state.systemMgmt.mailtemplates
  );
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const { data: employees } = useEmployee();

  const { data: detail, isLoading: isLoadingDetailRequest } = useQuery({
    queryKey: ["detail-summary-employee-request", id],
    queryFn: () =>
      HOSummaryEmployeeRequestService.getDetailsSummaryEmployeeRequest(id),
    onSuccess: (data) => {
      setERequests(
        data?.fields?.eContent ? JSON.parse(data.fields.eContent) : []
      );
    },
  });

  const approveRequest = async () => {
   
      try {
        if (getNextStep() === 1) {
          // const resp =
          //   await HOSummaryEmployeeRequestService.updateSummaryEmployeeRequest(
          //     id,
          //     {
          //       eApprovedStatus: requestStatus.approved,
          //       eApprovedDate: getUCTDate(),
          //       eRequestStatus: requestStatus.approved,
          //       eApprovalComment: form.getFieldValue("comment") || "",
          //     }
          //   );

          sendMail(
            `${detail?.fields?.eApprovedByITLead}|${
              getEmployeeDetail(
                detail?.fields?.eApprovedByITLead || "",
                employees,
                softwares
              )?.[0]?.Title
            }`,
            detail,
            MAIL_TEMPLATE.APPROVE
          );

        } else if (getNextStep() === 2) {
          // const resp =
          //   await HOSummaryEmployeeRequestService.updateSummaryEmployeeRequest(
          //     id,
          //     {
          //       eApprovedByITLeadStatus: requestStatus.approved,
          //       eApprovedByITLeadDate: getUCTDate(),
          //       eITLeadComment: form.getFieldValue("comment") || "",
          //       eRequestStatus: requestStatus.completed,
          //     }
          //   );

          sendMail(
            `${detail.createdBy?.user?.email}|${detail.createdBy?.user?.displayName}`,
            detail,
            MAIL_TEMPLATE.FINISH
          );
        }
      } catch (error) {
        CreateNotification({
          title: "Thất bại",
          body: `Duyệt thất bại`,
          icon: "/icons/error.png",
        });
        history.push(PATH.HOME);
      }

      CreateNotification({
        title: "Thành công",
        body: `Đồng ý thành công.`,
        icon: "/icons/success.png",
      });
      history.push(PATH.HOME);
  };

  const isEnableAccept = () => {
    const nextStep = getNextStep();

    if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
      return false;
    }

    if (
      detail?.fields?.eApprovedBy === currentUserName &&
      nextStep === 1 &&
      detail?.fields?.eApprovedStatus === requestStatus.submitted
    ) {
      return true;
    }

    if (
      detail?.fields?.eApprovedByITLead === currentUserName &&
      nextStep === 2 &&
      detail?.fields?.eApprovedByITLeadStatus === requestStatus.submitted
    ) {
      return true;
    }

    if (
      detail?.fields?.eApprovedByITHead === currentUserName &&
      nextStep === 3 &&
      detail?.fields?.eApprovedByITHeadStatus === requestStatus.submitted
    ) {
      return true;
    }

    if (
      detail?.fields?.eAssignee === currentUserName &&
      nextStep === 4 &&
      detail?.fields?.eAssigneeStatus === requestStatus.submitted
    ) {
      return true;
    }

    return false;
  };

  const isEnableRevoke = () => {
    const currentStep = getRevokeStep();

    if (currentStep === 1 && detail?.fields?.eApprovedBy === currentUserName) {
      return true;
    }

    if (
      currentStep === 2 &&
      detail?.fields?.eApprovedByITLead === currentUserName
    ) {
      return true;
    }

    if (
      currentStep === 3 &&
      detail?.fields?.eApprovedByITHead === currentUserName
    ) {
      return true;
    }

    return false;
  };

  const rejectRequest = async () => {
    if (!form.getFieldValue("comment")) {
      CreateNotification({
        title: "Thất bại",
        body: `Vui lòng nhập lý do từ chối`,
        icon: "/icons/error.png",
      });

      return;
    }

    try {
      if (getNextStep() === 1) {
        // const resp =
        //   await HOSummaryEmployeeRequestService.updateSummaryEmployeeRequest(
        //     id,
        //     {
        //       eRequestStatus: requestStatus.rejected,
        //       eApprovedStatus: requestStatus.rejected,
        //       eApprovedDate: getUCTDate(),
        //       eApprovalComment: form.getFieldValue("comment") || "",
        //     }
        //   );
        sendMail(
          `${detail.createdBy?.user?.email}|${detail.createdBy?.user?.displayName}`,
          detail,
          MAIL_TEMPLATE.REJECT
        );
      } else if (getNextStep() === 2) {
        // const resp =
        //   await HOSummaryEmployeeRequestService.updateSummaryEmployeeRequest(
        //     id,
        //     {
        //       eRequestStatus: requestStatus.rejected,
        //       eApprovedByITLeadStatus: requestStatus.rejected,
        //       eApprovedByITLeadDate: getUCTDate(),
        //       eITLeadComment: form.getFieldValue("comment") || "",
        //     }
        //   );
        sendMail(
          `${detail.createdBy?.user?.email}|${detail.createdBy?.user?.displayName}`,
          detail,
          MAIL_TEMPLATE.REJECT
        );
      }
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Từ chối thất bại`,
        icon: "/icons/error.png",
      });
      history.push(PATH.HOME);
    }

    CreateNotification({
      title: "Thành công",
      body: `Từ chối thành công.`,
      icon: "/icons/success.png",
    });

    history.push(PATH.HOME);
  };

  const revokeApproval = async () => {
    const currentStep = getRevokeStep();
    try {
      if (currentStep === 1) {
        // const resp =
        //   await HOSummaryEmployeeRequestService.updateSummaryEmployeeRequest(
        //     id,
        //     {
        //       eRequestStatus: requestStatus.submitted,
        //       eApprovedStatus: requestStatus.submitted,
        //       eApprovedDate: getUCTDate(),
        //     }
        //   );
      } else if (currentStep === 2) {
        // const resp =
        //   await HOSummaryEmployeeRequestService.updateSummaryEmployeeRequest(
        //     id,
        //     {
        //       eRequestStatus: requestStatus.submitted,
        //       eApprovedByITLeadStatus: requestStatus.submitted,
        //       eApprovedByITLeadDate: getUCTDate(),
        //       eITLeadComment: form.getFieldValue("comment") || "",
        //     }
        //   );
      } else if (currentStep === 3) {
        // const resp =
        //   await HOSummaryEmployeeRequestService.updateSummaryEmployeeRequest(
        //     id,
        //     {
        //       eRequestStatus: requestStatus.submitted,
        //       eApprovedByITHeadStatus: requestStatus.submitted,
        //       eApprovedByITHeadDate: getUCTDate(),
        //       eITHeadComment: form.getFieldValue("comment") || "",
        //     }
        //   );
      }

      CreateNotification({
        title: "Thành công",
        body: `Thu hồi thành công.`,
        icon: "/icons/success.png",
      });

      history.push(PATH.HOME);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Thu hồi thất bại`,
        icon: "/icons/error.png",
      });

      history.push(PATH.HOME);
    }
  };

  const getRevokeStep = () => {
    const nextStep = getNextStep();

    if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
      return 0;
    }

    if (
      detail?.fields?.eApprovedBy === currentUserName &&
      nextStep === 2 &&
      detail?.fields?.eApprovedStatus === requestStatus.approved
    ) {
      return 1;
    }

    if (
      detail?.fields?.eApprovedByITLead === currentUserName &&
      nextStep === 3 &&
      detail?.fields?.eApprovedByITLeadStatus === requestStatus.approved
    ) {
      return 2;
    }

    if (
      detail?.fields?.eApprovedByITHead === currentUserName &&
      nextStep === 4 &&
      detail?.fields?.eApprovedByITHeadStatus === requestStatus.approved
    ) {
      return 3;
    }

    return 0;
  };

  const getNextStep = () => {
    if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
      return -1;
    }

    if (detail?.fields?.eApprovedStatus === requestStatus.submitted) {
      return 1;
    }

    if (detail?.fields?.eApprovedByITLeadStatus === requestStatus.submitted) {
      return 2;
    }

    if (detail?.fields?.eApprovedByITHeadStatus === requestStatus.submitted) {
      return 3;
    }

    if (detail?.fields?.eAssigneeStatus === requestStatus.submitted) {
      return 4;
    }

    return 5;
  };

  if (isLoadingDetailRequest) {
    return <Skeleton />;
  }

  const siteUrl = getEnv("REACT_APP_SUMMARY_REGISTER_REQUEST");

  const sendMail = async (
    approver: any,
    itRepairToolRequest: any,
    type: string
  ) => {
    const url = siteUrl + "/details/" + itRepairToolRequest.id;
    const arr = approver.split("|");
    const tomail = arr.length > 0 ? arr[0] : "";
    const name = arr.length > 1 ? arr[1] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === type);
    let content = "";

    if (type[3].toLowerCase() === "f") {
      content = template.eContent
        .replace(mailRegexs.zero, name)
        .replace(mailRegexs.one, form.getFieldValue("comment") || "");
    } else {
      content = template.eContent
        .replace(mailRegexs.zero + ";", name)
        .replace(mailRegexs.one + ";", "duyệt")
        .replace(
          mailRegexs.two + ";",
          itRepairToolRequest?.createdBy?.user?.displayName
        )
        .replace(
          mailRegexs.three + ";",
          `${getDDMMYYYFormat(
            itRepairToolRequest.createdDateTime
          )} - ${getHHmmFormat(itRepairToolRequest.createdDateTime)}`
        )
        .replace(mailRegexs.siteUrl, url);
    }

    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(
      subject,
      content,
      "html",
      tomail
    );
    await MailService.sendMail(message);
  };

  const showRejectConfirm = () => {
    Modal.confirm({
      title: <StyledTitle level={5}>Thông báo</StyledTitle>,
      content: (
        <>
          Bạn có chắc chắn muốn từ chối yêu cầu này ?
          <br />
          Vui lòng nhập lý do từ chối
          <br />
          <StyledTitle level={5}>
            Lý do <span className="text-danger ml-1">*</span>{" "}
          </StyledTitle>
          <Input
            onChange={(e: any) => {
              form.setFieldValue("comment", e.target.value);
            }}
          />
        </>
      ),
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      cancelButtonProps: {
        style: { backgroundColor: "orange", color: "white" },
      },

      onOk() {
        rejectRequest();
      },
      onCancel() {
        form.setFieldValue("comment", null);
      },
    });
  };

  return (
    <div className="ItCodeGrantedDetailPage pd15">
      <div className="PageHead">
        <div className="title">
          <div className="btnBack" onClick={() => history.push(PATH.HOME)}>
            <Icon.ArrowLeft />
          </div>
          Xem Xét Yêu Cầu Duyệt
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 col-md-12">
          <ExportProgress />
          <ExportInformation eRequests={eRequests} />
          <ExportList
            eRequests={eRequests}
            setERequests={setERequests}
            hiddenEdit={getNextStep() === 1 ? false : true}
          />
          <ExportHistory form={form} isEnableAccept={isEnableAccept()} />

          <div className="d-flex justify-content-center">
            {isEnableAccept() && (
              <StyledButton
                bgColor="green"
                className="mr-3"
                type="primary"
                onClick={approveRequest}
              >
                Đồng ý
              </StyledButton>
            )}

            {isEnableAccept() && (
              <StyledButton
                bgColor="grey"
                className="mr-3"
                onClick={showRejectConfirm}
                type="primary"
              >
                Không đồng ý
              </StyledButton>
            )}

            {!isEnableAccept() && isEnableRevoke() && (
              <StyledButton
                bgColor="grey"
                className="mr-3"
                onClick={revokeApproval}
              >
                Thu hồi
              </StyledButton>
            )}

            {isEnableEdit(getNextStep(), detail, currentUserName) && (
              <StyledButton
                bgColor="orange"
                onClick={() => {
                  history.push(PATH.CREATE.replace(":id", id));
                }}
              >
                Chỉnh sửa
              </StyledButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});
